import { render, staticRenderFns } from "./FolderOverallPriority.vue?vue&type=template&id=e072ec46"
import script from "./FolderOverallPriority.vue?vue&type=script&lang=js"
export * from "./FolderOverallPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports